import "@/App.css";
import { router } from "@/router";
import { generateColors } from "@mantine/colors-generator";
import {
  Accordion,
  createTheme,
  MantineProvider,
  Select,
  Switch,
  Textarea,
  TextInput,
} from "@mantine/core";
import "@mantine/core/styles.css";
import { DatePickerInput } from "@mantine/dates";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import { IconContext } from "@phosphor-icons/react";
import { RouterProvider } from "react-router-dom";
import "tippy.js/animations/shift-toward.css";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";

export const COLORS = {
  universalGray: "#636363",
  foreground: "#191919",
};

export const theme = createTheme({
  radius: {
    full: "9999px",
  },
  breakpoints: {
    xs: "479px",
    sm: "767px",
    md: "1023px",
    lg: "1183px",
    xl: "1439px",
    "2xl": "1679px",
  },
  primaryColor: "giclee",
  colors: {
    giclee: generateColors("#4AA0A0"),
    canvas: generateColors("#4AA0A0"),
    hdalu: generateColors("#4AA0A0"),
    // canvas: generateColors("#C39865"),
    // hdalu: generateColors("#8E7D9F"),
  },
  fontFamily: "Afacad",
  components: {
    Table: {
      classNames: { td: "text-[16px]", th: "text-[16px]" },
      defaultProps: { verticalSpacing: "md" },
    },
    Modal: {
      styles: {
        title: { fontSize: "24px", fontWeight: 500 },
        header: { borderBottom: "1px solid var(--gray-200)" },
        close: { width: 36, height: 36, borderRadius: 9999 },
      },
    },
    Tabs: { classNames: { tabLabel: "text-[18px] text-muted" } },
    TextInput: TextInput.extend({ classNames: { label: "text-neutral-500" } }),
    ColorInput: TextInput.extend({ classNames: { label: "text-neutral-500" } }),
    Textarea: Textarea.extend({ classNames: { label: "text-neutral-500" } }),
    Select: Select.extend({ classNames: { label: "text-neutral-500" } }),
    DatePickerInput: DatePickerInput.extend({
      classNames: { label: "text-neutral-500" },
    }),
    Switch: Switch.extend({
      classNames: { trackLabel: "cursor-pointer", thumb: "cursor-pointer" },
    }),
    Accordion: Accordion.extend({
      defaultProps: { radius: 12 },
      styles: {
        control: {
          padding: "16px",
          backgroundColor: "#fcfcfc",
        },
        panel: {
          backgroundColor: "#fcfcfc",
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
        },
      },
    }),
  },
});

export const App = () => {
  return (
    <MantineProvider theme={theme}>
      <IconContext.Provider value={{ size: 16 }}>
        <Notifications position="top-right" />
        <RouterProvider router={router} />
      </IconContext.Provider>
    </MantineProvider>
  );
};

export default App;
